// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  apiUrl: 'https://alreadydone.us/api/',
  googleClientId: '967064669269-2l6obr0s1t1tgra62dslcgcr49trmc5c.apps.googleusercontent.com',
  appleClientId: 'com.alreadydone.signin',
  // Publishable keys are safe to ship client-side — get one from https://dashboard.stripe.com/test/apikeys
  stripePublishableKey: 'pk_test_51U2XPvBhrnszrtdfz7L1V1UPatgBkINVPAjVJcwJaCnKKMFSkCxmgMuCyDZvoBn8jFLeYxxrpfj4FgOy3E8zrVaW008rEn4Erq',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
